import { Box } from '@chakra-ui/react';
import { PersonalizedBannerItem } from '@diamond/shared/types';
import { type SortableItem, DropResult, Sortable } from '@diamond/shared/ui';
import { useMemo } from 'react';

import { BannerItem } from './banner-item';

interface BannerListProps {
  data: PersonalizedBannerItem[];
  onDelete: (id: string) => void;
  onEdit: (id: string) => void;
  onDuplicate: (id: string) => void;
  onIndexChange: (result: DropResult) => void;
  onMoveToTop: (id: string) => void;
  totalItems?: number;
  itemsPerPage?: number;
}

export function BannerList({
  data,
  onDelete,
  onEdit,
  onDuplicate,
  onIndexChange,
  onMoveToTop,
  totalItems,
  itemsPerPage,
}: BannerListProps) {
  const items: SortableItem[] = useMemo(
    () =>
      data.map((banner) => ({
        id: banner.id,
        children: (
          <BannerItem
            item={banner}
            onDelete={onDelete}
            onEdit={onEdit}
            onDuplicate={onDuplicate}
          />
        ),
      })),
    [data, onDelete, onEdit, onDuplicate]
  );

  return (
    <Box my={8} width="full">
      <Sortable
        data={items}
        handleChange={onIndexChange}
        handleMoveToTop={onMoveToTop}
        showMoveToTopOnLastItems
        totalItems={totalItems}
      />
    </Box>
  );
}
